<template>
  <div v-if="user" class="w-full h-full overflow-auto">
      <div id="content">
        <div class="w-full h-full p-4">
          <Dashboard :user="user" v-if="panel === 'Dashboard'" />
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/Dashboard.vue'
import API from '@/API'
export default {
  name: 'HomeView',
  components: {
    Dashboard
  }, data() {
    return {
      route: this.$router.currentRoute.value.name,
      panel: this.$route.query.panel,
      user: null,
      expand: true,
    }
  },
  methods: {
    toggleMenu() {
      this.expand = !this.expand
    }
  },
  created() {
    API.checkAuth((r, status) => {
      if (status === 200) {
        this.user = r
      }else if(status === 401){
        window.location=process.env.VUE_APP_LOGIN_URL
      }
    })
    // dont expand if screen is small
    if (window.innerWidth < 1024) {
      this.expand = false;
    }
  }
}
</script>
